export class ImageService {
  static getLocalIconPath(folder: string, icon: string, type?: string): string {
    return new URL(
      `../assets/icons/${folder}/${icon}.${type || "svg"}`,
      import.meta.url
    ).href;
  }

  static getLocalImgPath(folder: string, img: string, type?: string): string {
    return new URL(
      `../assets/imgs/${folder}/${img}.${type || "svg"}`,
      import.meta.url
    ).href;
  }
}
